import  styles from './styles.module.css'

const Input = ({id,name,label,type = "text", placeholder='', disabled,register,required,errors}) => {
    
    if(type === 'checkbox') {
        return(
            <input 
                className="form-check-input" 
                type={type} 
                id={id}
                disabled={disabled}
                name={name}
                {...register(id, { required })} 
            />
        )
    }

    if(type === 'textarea'){
        return (
            <>
                <textarea                
                    id={id}
                    disabled={disabled}
                    name={name}
                    placeholder={placeholder}
                    style={{minHeight:"150px",resize:"none"}}
                    {...register(id, { required: "This is required." })} 
                    className={`form-control mt-3 ${styles['input-custom']} ${errors[id] ? 'is-invalid':''}`} 
                ></textarea>

                <div className="invalid-feedback">{errors[id]?.message}</div>
            </>
        )
    }


    return (
        <>
            {/* <label className={`${styles['lable-style']}`} htmlFor={id}>{label}</label> */}
            <input 
                type={type} 
                id={id}
                disabled={disabled}
                name={name}
                placeholder={placeholder}
                {...register(id, { required: "This is required." })} 
                className={`form-control form-control-lg mt-3 ${styles['input-custom']} ${errors[id] ? 'is-invalid':''}`} 
            />
            <div className="invalid-feedback">{errors[id]?.message}</div>
        </>
    );
};

export default Input;

// 